import { createApp } from 'vue';
import App from './App'
import router from './router'
import store from './store'
import api from "@/services";
import device from 'current-device';
import moment from 'moment';

import "./assets/styles/global.scss";
import "./assets/styles/animation.scss";

const app = createApp(App);
app.config.productionTip = false;
app.config.globalProperties.$api = api;
app.use(router).use(store);

//ant
import {
    Button, Dropdown, Menu, Spin, Tooltip, Input, Popconfirm, ConfigProvider, Empty, Checkbox, Modal, Alert,
    Table, Select, Breadcrumb, Pagination, Image, InputNumber, Form, Radio, notification, message,
} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less';

app.use(Button).use(Dropdown).use(Menu).use(Spin).use(Tooltip).use(Input).use(Popconfirm).use(ConfigProvider)
    .use(Empty).use(Checkbox).use(Modal).use(Alert).use(Table).use(Select).use(Breadcrumb).use(Pagination)
    .use(Image).use(InputNumber).use(Form).use(Radio);
message.config({
    duration: 2,
    maxCount: 1,
    key: 1
})

app.config.globalProperties.$notification = notification;
app.config.globalProperties.$message = message;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$device = device;
app.config.globalProperties.$confirm = function confirm(title, callback) {
    Modal.confirm({
        okText: '确认',
        cancelText: '取消',
        title: title,
        onOk: () => {
            return callback();
        }
    })
}

app.mount('#app')